export default "__VITE_ASSET__dbfc5d56__"